import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import ActivityForm from "./ActivityForm";

import {
  AdminButton,
} from "../../pages/admin/action_engine";

import {
  AdminActions,
} from "../../pages/admin/section_engine";


export const EMPTY_ACTIVITY_CREATE_FORM =
  Object.freeze({
    name: "",
    activity_type: "",
    company_name: "",
    company_siret: "",
    company_uuid: null,
    description: "",
    default_vat_rate: 20,
    sale_account_code: "",
    purchase_account_code: "",
    vat_account_code: "",
    revenue_label: "",
  });


export function createActivityCreateFormValue(
  overrides = {},
) {
  return {
    ...EMPTY_ACTIVITY_CREATE_FORM,
    ...overrides,
  };
}


export function validateActivityCreateForm(
  value,
  {
    requireCompanyUuid = true,
  } = {},
) {
  if (
    !String(
      value?.name || ""
    ).trim()
    || !String(
      value?.activity_type || ""
    ).trim()
  ) {
    return (
      "Le nom et le type d’activité "
      + "sont obligatoires."
    );
  }

  if (
    requireCompanyUuid
    && !value?.company_uuid
  ) {
    return (
      "Sélectionnez une société existante "
      + "pour rattacher l’activité."
    );
  }

  if (
    !requireCompanyUuid
    && !value?.company_uuid
    && !String(
      value?.company_name || ""
    ).trim()
  ) {
    return (
      "Le rattachement société "
      + "est obligatoire."
    );
  }

  return null;
}


export default function ActivityCreateForm({
  value,
  onChange,
  blueprints,
  saving,
  onSubmit,
  onCancel,
  requireCompanyUuid = true,
  activityTypeLocked = false,
  submitLabel = "Créer l’activité",
  accountCodes = [],
}) {
  const validationError =
    validateActivityCreateForm(
      value,
      {
        requireCompanyUuid,
      },
    );


  return (
    <FormRoot
      data-testid="activity-create-form"
    >
      <ActivityForm
        value={value}
        onChange={onChange}
        blueprints={blueprints}
        requireCompanyUuid={
          requireCompanyUuid
        }
        activityTypeLocked={
          activityTypeLocked
        }
        accountCodes={
          accountCodes
        }
      />


      <AdminActions>
        <AdminButton
          variant="success"
          type="button"
          onClick={onSubmit}
          disabled={
            saving
            || Boolean(validationError)
          }
          loading={saving}
        >
          {saving
            ? "Création..."
            : submitLabel}
        </AdminButton>

        {onCancel ? (
          <AdminButton
            variant="ghost"
            type="button"
            onClick={onCancel}
            disabled={saving}
          >
            Annuler
          </AdminButton>
        ) : null}
      </AdminActions>
    </FormRoot>
  );
}


ActivityCreateForm.propTypes = {
  value:
    PropTypes.shape({
      name: PropTypes.string,
      activity_type: PropTypes.string,
      company_name: PropTypes.string,
      company_siret: PropTypes.string,
      company_uuid: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
      ]),
      description: PropTypes.string,
      default_vat_rate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      sale_account_code: PropTypes.string,
      purchase_account_code: PropTypes.string,
      vat_account_code: PropTypes.string,
      revenue_label: PropTypes.string,
    }).isRequired,

  onChange:
    PropTypes.func.isRequired,

  blueprints:
    PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        activity_type:
          PropTypes.string.isRequired,
        label:
          PropTypes.string.isRequired,
      }),
    ),

  saving:
    PropTypes.bool,

  onSubmit:
    PropTypes.func.isRequired,

  onCancel:
    PropTypes.func,

  requireCompanyUuid:
    PropTypes.bool,

  activityTypeLocked:
    PropTypes.bool,

  submitLabel:
    PropTypes.string,

  accountCodes:
    PropTypes.arrayOf(
      PropTypes.shape({
        uuid:
          PropTypes.string,

        category:
          PropTypes.string,

        subcategory:
          PropTypes.string,

        code:
          PropTypes.string,

        description:
          PropTypes.string,
      })
    ),
};


ActivityCreateForm.defaultProps = {
  blueprints: [],
  saving: false,
  onCancel: null,
  requireCompanyUuid: true,
  activityTypeLocked: false,
  submitLabel: "Créer l’activité",
};


const FormRoot = styled.div`
  display: grid;
  gap: 1rem;
`;


const CompanyRequirement =
  styled.div`
    grid-column: 1 / -1;

    padding:
      0.7rem
      0.8rem;

    border-radius:
      0.55rem;

    background:
      rgba(
        245,
        158,
        11,
        0.10
      );

    font-size:
      0.84rem;
  `;
